export default "__VITE_ASSET__DY7nNJXD__"